let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jTqsp")).then(() => parcelRequire('lhJ8i'));